/**
 * Analytics micro-conversion tracker.
 * Emits both:
 *  - window.dataLayer.push({ event, ...params })   → picked up by GTM
 *  - window.gtag('event', event, params)           → picked up by GA4 directly
 *
 * Standardized events used across the site:
 *  - contact_whatsapp   { location, service? }
 *  - contact_schedule   { location, service? }   ← Calendly click
 *  - generate_lead      { lead_source, service?, budget? }  (already emitted in forms)
 */
export function trackEvent(name, params = {}) {
    if (typeof window === "undefined") return;
    try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: name, ...params });
    } catch (_) {
        // ignore
    }
    try {
        if (typeof window.gtag === "function") {
            window.gtag("event", name, params);
        }
    } catch (_) {
        // ignore
    }
}
